
export function Nav()
{
	return (
		<svg id="nav" class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M60 16H4c-2.2 0-4-1.8-4-4s1.8-4 4-4h56c2.2 0 4 1.8 4 4s-1.8 4-4 4zM60 56H4c-2.2 0-4-1.8-4-4s1.8-4 4-4h56c2.2 0 4 1.8 4 4s-1.8 4-4 4zM60 36H4c-2.2 0-4-1.8-4-4s1.8-4 4-4h56c2.2 0 4 1.8 4 4s-1.8 4-4 4z"/></svg>
	);
}
